module.exports = __webpack_public_path__ + "img/restauri_interni.e0a42623.jpg";